import { Box, Popover, Typography, Skeleton } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFreeTablesData,
  updateActivityDuration,
  updateTime,
} from "../../store/slice/Activity.slice";
import { getFreeTables } from "../../api/HorecaWidget.service";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { fetchActivitesTime } from "../../api/activity.service";
import { useTheme } from "@emotion/react";
import { formatTimeString, format_Number } from "../../utils/utils";

const TimeComponent = ({ isOpen, handleClose, Ref,isDuration=false }) => {
  const theme=useTheme()
  const [isLoading, setIsLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { reservType, selectedDate, totalCount, defaultLanguage, time,freeTablesData,activityDuration,ActivityData,languageWords } =
    useSelector((store) => store?.Activity);
    const prevDate = useRef(selectedDate);
  const {key, widgetSetupId } = useSelector(
    (store) => store?.widgetSettings
  );

const formatName = (name) => {
  const regex = /price(\d+)Hour(?:s)?(?:(\d+)Minutes)?/;
  const match = name.match(regex);

  if (match) {
    let hours = parseInt(match[1], 10);
    let minutes = match[2] ? parseInt(match[2], 10) : 0;

    let formattedName = `${hours} ${languageWords?.hrs}`;
    if (minutes > 0) {
      formattedName += ` ${minutes} ${languageWords?.mins}`;
    }

    return formattedName;
  }

  return name;
};
  return (
    <Popover
      open={isOpen}
      anchorEl={Ref}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <Box
        sx={{
          width:isDuration ? "550px" : "480px",
          //height: "602px",
          maxHeight:"450px",
         // overflow:'auto',    
         backgroundColor: theme?.time?.bgColor,
          p: 2,
        
        }}
        className="times"
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            my: 2,
          }}
        >
          <Typography
            sx={{ color:  theme?.time?.itemTextColor, fontSize: "14px", fontWeight: "bold" }}
          >
           {isDuration ? languageWords?.labelSelectDuration: languageWords?.labelSelectTime }
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          {isLoading
            ? // Render Skeletons while loading
              Array.from(new Array(5)).map((_, index) => (
                <Box
                  key={index}
                  sx={{
                    width: "137px",
                    height: "51px",
                    border: "1px solid #C9C9C9",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "5px",
                  }}
                >
                  <Skeleton variant="text" width={80} height={30} />
                </Box>
              ))
            : isDuration ? reservType?.products?.filter((prod) => prod?.price > 0)?.map((item, index) => (
              <Box
                  key={index}
                  sx={{
                   
                    minWidth: "150px",
                    minHeight: "51px",
                    border: "1px solid ",
                    p:1,
                    borderColor: theme?.time?.itemBorder,
                    backgroundColor: activityDuration?.name === item?.name
                      ? theme?.time?.itemBGActive
                      : theme.time.itemBG,
                    color: activityDuration?.name === item?.name
                      ? theme?.time?.itemTextActive
                      : theme?.time?.itemTextColor,
                    "&:hover": {
                      backgroundColor: theme?.time?.itemBgHover,
                      "& .text": {
                        color: activityDuration?.name === item?.name ? theme?.time?.itemTextColor :theme?.time?.itemTextHover,
                      },
                    },      
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease",
                    borderRadius: "5px",
                   
                  }}
                  onClick={() => {
                     dispatch(updateActivityDuration(item));
                    dispatch(updateTime(''))
                    handleClose();
                  }}
                >
                  <Box sx={{display:"flex",flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                  <Typography
                  sx={{fontWeight:"bold"}}
                   
                  >
                    {formatTimeString(item?.timeText,languageWords)}
                  </Typography>
                  <small
                   style={{color: activityDuration?.name === item?.name ? "white" : "grey"}}
                   >
                     &euro;{format_Number(item?.price)}
                   </small>
                  </Box>
                </Box>

            )):
              freeTablesData?.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    width: "137px",
                    height: "51px",
                    border: "1px solid",
                    borderColor:  theme?.time?.itemBorder,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: item.locked ? "not-allowed" : "pointer",
                    transition: "background-color 0.3s ease",
                    borderRadius: "5px",
                    backgroundColor: time === item?.time
                      ? theme?.time?.itemBGActive
                      : theme.time.itemBG,
                    color: time === item.time
                      ? theme?.time?.itemTextActive
                      : theme?.time?.itemTextColor,
                    "&:hover": {
                      backgroundColor: theme?.time?.itemBgHover,
                      "& .text": {
                        color: item?.locked ? theme?.time?.itemTextColor :theme?.time?.itemTextHover,
                      },
                    },
                    textDecoration: item?.locked ? "line-through" : "none", // Strikethrough if locked
                    opacity: item?.locked ? 0.5 : 1, // Optional: dim locked items
                  }}
                  // sx={{
                  //   width: "137px",
                  //   height: "51px",
                  //   border: "1px solid ",
                  //   borderColor: time == item ? "#FFCC00" : "#C9C9C9",
                  //   display: "flex",
                  //   justifyContent: "center",
                  //   alignItems: "center",
                  //   cursor: "pointer",
                  //   transition: "background-color 0.3s ease",
                  //   borderRadius: "5px",
                  //   backgroundColor:
                  //     time == item ? "#FFCC00" : "transparent",
                  // }}
                  onClick={() => {
                    dispatch(updateTime(item));
                    handleClose();
                  }}
                >
                  <Typography
                 
                  >
                    {item?.substring(0, 5)}
                  </Typography>
                </Box>
              ))}
        </Box>
      </Box>
    </Popover>
  );
};


export default TimeComponent;
